// extracted by mini-css-extract-plugin
module.exports = {"container":"back-arrow_container__JeIHa"};